"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearChoicePalette = void 0;
var palette_1 = require("../../shared/palette");
var palette = {
    primary: {
        '100': '#E6EAEE',
        '300': '#B6C1CC',
        '500': '#0A2F54',
        '700': '#082643',
        '900': '#061C32',
    },
    secondary: {
        '100': '#E6EAEE',
        '300': '#B6C1CC',
        '500': '#0A2F54',
        '700': '#082643',
        '900': '#061C32',
    },
    tertiary: {
        '100': '#EFF9FE',
        '300': '#D0EEFC',
        '500': '#61C6F5',
        '700': '#4E9EC4',
        '900': '#3A7793',
    },
    neutrals: __assign(__assign({}, palette_1.commonNeutrals), { '100': '#F0F4F7', '300': '#D3DBE3', '500': '#A8B1BA', '700': '#69727B', '900': '#474F57' }),
    text: __assign(__assign({}, palette_1.commonTextColors), { disabled: '#A8B1BA', tertiary: '#727272', secondary: '#474F57', primary: '#0A2F54', interactive: '#036896' }),
    accent01: {
        '100': '#FFF6EC',
        '300': '#FEE6C8',
        '500': '#FAAB46',
        '700': '#C88938',
        '900': '#96672A',
    },
    accent02: {
        '100': '#F9FBFD',
        '300': '#EEF3F9',
        '500': '#C7D8EA',
        '700': '#9FADBB',
        '900': '#77828C',
    },
    accent03: {
        '100': '#FAFCFA',
        '300': '#F2F7F0',
        '500': '#D2E3CC',
        '700': '#A8B6A3',
        '900': '#7E887A',
    },
    accent04: {
        '100': '#FCFCFF',
        '300': '#F7F8FF',
        '500': '#E3E6FF',
        '700': '#B6B8CC',
        '900': '#888A99',
    },
    success: __assign(__assign({}, palette_1.commonSuccess), { '700': '#027356' }),
    error: __assign({}, palette_1.commonError),
    warning: __assign({}, palette_1.commonWarning),
    info: __assign({}, palette_1.commonInfo),
    background: __assign(__assign(__assign({}, palette_1.commonBackgroundColors), palette_1.commonGradients), { neutral: '#E7E7E7', light: '#C7D8EA', lightTwo: '#E3E6FF', lightThree: '#D2E3CC', dark: '#0A2F54', darkTwo: '#082643', neutralGradient: 'linear-gradient(180deg, #E7E7E7 0%, #FFFFFF 70%)', lightGradient: 'linear-gradient(180deg, #BFD7EE 0%, rgba(255, 255, 255, 0.70) 100%)', lightTwoGradient: 'linear-gradient(180deg, #E3E6FF 0%, #FFFFFF 70%)', lightThreeGradient: 'linear-gradient(180deg, #D2E3CC 0%, #FFFFFF 70%)', darkGradient: 'linear-gradient(165deg, #0A2F54 4.91%, #1A4C80 89.46%)', ODPHeroGradient: 'linear-gradient(97deg, rgba(10, 47, 84, 0.85) 33.86%, rgba(10, 47, 84, 0.00) 73.68%)' }),
};
exports.clearChoicePalette = {
    primary: {
        lightest: palette.primary[100],
        light: palette.primary[300],
        main: palette.primary[500],
        dark: palette.primary[700],
        darkest: palette.primary[900],
    },
    secondary: {
        lightest: palette.secondary[100],
        light: palette.secondary[300],
        main: palette.secondary[500],
        dark: palette.secondary[700],
        darkest: palette.secondary[900],
    },
    tertiary: {
        lightest: palette.tertiary[100],
        light: palette.tertiary[300],
        main: palette.tertiary[500],
        dark: palette.tertiary[700],
        darkest: palette.tertiary[900],
    },
    neutrals: {
        white: palette.neutrals.white,
        neutral: palette.neutrals[100],
        primary: palette.neutrals[300],
        disabled: palette.neutrals[500],
        secondary: palette.neutrals[900],
        tertiary: palette.neutrals[700],
    },
    text: {
        primary: palette.text.primary,
        secondary: palette.text.secondary,
        tertiary: palette.text.tertiary,
        light: palette.text.light,
        disabled: palette.text.disabled,
        interactive: palette.text.interactive,
    },
    accent01: {
        lightest: palette.accent01[100],
        light: palette.accent01[300],
        main: palette.accent01[500],
        dark: palette.accent01[700],
        darkest: palette.accent01[900],
    },
    accent02: {
        lightest: palette.accent02[100],
        light: palette.accent02[300],
        main: palette.accent02[500],
        dark: palette.accent02[700],
        darkest: palette.accent02[900],
    },
    accent03: {
        lightest: palette.accent03[100],
        light: palette.accent03[300],
        main: palette.accent03[500],
        dark: palette.accent03[700],
        darkest: palette.accent03[900],
    },
    accent04: {
        lightest: palette.accent04[100],
        light: palette.accent04[300],
        main: palette.accent04[500],
        dark: palette.accent04[700],
        darkest: palette.accent04[900],
    },
    success: {
        light: palette.success[300],
        main: palette.success[500],
        dark: palette.success[700],
    },
    error: {
        light: palette.error[300],
        main: palette.error[500],
        dark: palette.error[700],
    },
    warning: {
        light: palette.warning[300],
        main: palette.warning[500],
        dark: palette.warning[700],
    },
    info: {
        light: palette.info[300],
        main: palette.info[500],
        dark: palette.info[700],
    },
    backgrounds: __assign({}, palette.background),
};
